import { map, Observable } from 'rxjs';

import { PublicatableBaseModel, PublicationStatus } from '../models/classes/base/PublicatableBaseModel';
import { ContentElement } from '../models/classes/content-elements/ContentElement';
import { EntityService } from './entity.service';
import { Response } from './local/Response';

export class PublicatableEntityService<T extends PublicatableBaseModel, TCreate, TUpdate> extends EntityService<T, TCreate, TUpdate> {

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC INSTANCE METHODS
  // -----------------------------------------------------------------------------------------------------

  updateStatus(id: string, status: PublicationStatus): Observable<ContentElement> {
    return this.httpService
      .patch<Response<ContentElement>>(`${this.endpoint}/${id}/status`, { publicationStatus: status })
      .pipe(
        map((response: Response<ContentElement>) => response?.data)
      );
  }
}
